import { useTranslation } from 'react-i18next';

import LanguageIcon from '@mui/icons-material/Language';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import LoupeIcon from '@mui/icons-material/Loupe';
import { Box, Typography } from '@mui/material';

import CustomLink from '../../pages/DFMPage/components/CustomLink/CustomLink';

type Props = {
  uniqueDomain: string;
  linkedinUrl: string;
  pipedriveID?: string;
  direction?: 'row' | 'column';
  compact?: boolean;
};

const CompanyLinks = ({ uniqueDomain, linkedinUrl, pipedriveID, direction = 'column', compact = false }: Props) => {
  const { t } = useTranslation();
  const iconSx = compact ? { fontSize: 14 } : undefined;
  const linkSx = compact ? { fontSize: '0.75rem' } : undefined;

  return (
    <Box display="flex" flexDirection={direction} gap={direction === 'row' ? 1.5 : 0}>
      {/* Unique Domain Link */}
      <Box display="flex" alignItems="center" gap={0.5}>
        <LanguageIcon color="primary" fontSize="small" sx={iconSx} />
        {uniqueDomain ? (
          <CustomLink to={uniqueDomain} sx={linkSx}>
            {t('assessment.visitPage')}
          </CustomLink>
        ) : (
          <Typography color={'action.disabled'} sx={linkSx}>
            {t('assessment.visitPage')}
          </Typography>
        )}
      </Box>

      {/* LinkedIn Link */}
      <Box display="flex" alignItems="center" gap={0.5}>
        <LinkedInIcon color="primary" fontSize="small" sx={iconSx} />
        {linkedinUrl ? (
          <CustomLink to={linkedinUrl} sx={linkSx}>
            {t('assessment.visitLinkedin')}
          </CustomLink>
        ) : (
          <Typography color={'action.disabled'} sx={linkSx}>
            {t('assessment.visitLinkedin')}
          </Typography>
        )}
      </Box>

      {/* Conditionally render Pipedrive link if pipedriveID is passed */}
      {pipedriveID && (
        <Box display="flex" alignItems="center" gap={0.5}>
          <LoupeIcon color="primary" fontSize="small" sx={iconSx} />
          <CustomLink to={`https://bid.pipedrive.com/organization/${pipedriveID}`} sx={linkSx}>
            {t('assessment.visitPD')}
          </CustomLink>
        </Box>
      )}
    </Box>
  );
};

export default CompanyLinks;
